import { render, staticRenderFns } from "./palette-colors.vue?vue&type=template&id=19214733"
import script from "./palette-colors.vue?vue&type=script&lang=js"
export * from "./palette-colors.vue?vue&type=script&lang=js"
import style0 from "./palette-colors.vue?vue&type=style&index=0&id=19214733&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports